import {HostedInstanceResource} from "client/resources/hostedInstanceResource";
import {BackgroundTaskResource} from "client/resources/backgroundTaskResource";
import {ReefResource} from "client/resources/reefResource";
import {InstanceEnvironmentVariable} from "../../client/resources/instanceEnvironmentVariablesResource";

export const auditLinks = {
    root: "/audit",
    auditTrailFor: (document: ReefResource | HostedInstanceResource | BackgroundTaskResource | InstanceEnvironmentVariable) => `${auditLinks.root}?documentId=${document.Id}`
};